var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCeramicMug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28.587,
    viewBox: "0 0 32 28.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-944 -512.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-mug-6855423",
    transform: "translate(929.82 494.414)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "Path_63",
    "data-name": "Path 63",
    d: "M18.053,46.587H35.161a3.857,3.857,0,0,0,3.873-3.83V38.074h3.272a3.857,3.857,0,0,0,3.873-3.83V26.438a3.857,3.857,0,0,0-3.873-3.83H39.035V18.893A.893.893,0,0,0,38.142,18H15.073a.893.893,0,0,0-.893.893V42.757a3.857,3.857,0,0,0,3.873,3.83ZM42.306,24.395a2.067,2.067,0,0,1,2.087,2.043v7.806a2.068,2.068,0,0,1-2.087,2.043H39.035V24.395Zm-26.34-4.608H37.248V42.757A2.068,2.068,0,0,1,35.161,44.8H18.054a2.067,2.067,0,0,1-2.087-2.043Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeramicMug);
export default __webpack_public_path__ + "static/media/ceramicMug.77cd0d3596db24bf7711adfcff8d87c2.svg";
export { ForwardRef as ReactComponent };